<template>
  <div class="bodywarp">
    <el-card class="box-card boxcard" style="min-height:calc(100% - 30px)">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="公司名称">
          <el-select v-model="formInline.cztcode" clearable placeholder="请选择">
            <el-option v-for="item in selectlist" :key="item.ccorpcode" :label="item.ccorpname" :value="item.ccorpcode"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="送货日期">
          <!-- <el-date-picker v-model="formInline.ddeliverytime" type="date" value-format="yyyy-MM-dd" placeholder="送货日期"></el-date-picker> -->
          <el-date-picker v-model="formInline.ddeliverytime" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" @click.native="GetInvoiceList" size="medium">查询</el-button>
          </Debounce>
          <el-button type="success" size="medium" @click="addoption('1')">新增</el-button>
          <!-- <el-button type="warning" size="medium" plain @click="printpage()">打印</el-button> -->
        </el-form-item>
      </el-form>
      <div class="text item text-center">
        <div class="pull-right" style="margin-bottom:15px"></div>
        <el-table :data="orderlist" style="width: 100%" max-height="560" border :header-cell-style="{ background: '#eef1f6', textAlign: 'center' }" :cell-style="{ padding: '7px 0',textAlign: 'center'}" @current-change="clickChange">
          <!-- <el-table-column label="选择" width="55" fixed="left">
            <template slot-scope="scope">
              <el-radio v-model="tableRadio" :label="scope.row">
                <i>
                </i>
              </el-radio>
            </template>
          </el-table-column> -->
          <el-table-column prop="iinport" label="提交状态" width="120">
            <template slot-scope="scope">
              <el-tag type="success" size="small" v-if="scope.row.iinport=='1'">已提交</el-tag>
              <el-tag type="danger" size="small" v-else effect="dark">未提交</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="cpasturename" label="公司名称" min-width="200"></el-table-column>
          <el-table-column prop="cfpcode" label="发票号" min-width="120"></el-table-column>
          <el-table-column prop="cstatus" label="发票状态" width="100"></el-table-column>

          <!-- <el-table-column prop="cvenname" label="供应商" min-width="200"></el-table-column> -->
          <el-table-column prop="dpbvdate" label="发票日期" width="160">
            <template slot-scope="scope">
              <span v-if="scope.row.dpbvdate">
                {{scope.row.dpbvdate.substring(0,10)}}
              </span>

            </template>
          </el-table-column>
          <!-- <el-table-column prop="cexch_name" label="币种" width="70"></el-table-column> -->
          <!-- <el-table-column prop="iexch_rate" label="汇率" width="60"></el-table-column> -->
          <el-table-column prop="itotalmoney" label="含税金额" width="100"></el-table-column>
          <el-table-column prop="itaxmoney" label="不含税金额" width="100"></el-table-column>
          <el-table-column prop="CreateUserName" label="制单人" width="90"></el-table-column>
          <el-table-column prop="dinportdate" label="提交日期" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.dinportdate"> {{scope.row.dinportdate.substring(0,10)}}</span>

            </template>
          </el-table-column>
          <!-- <el-table-column prop="CreateDate" label="制单时间" width="100">
            <template slot-scope="scope" v-if="scope.row.CreateDate">
              {{scope.row.CreateDate.substring(0,10)}}
            </template>
          </el-table-column>

          <el-table-column prop="itotalqty" label="数量" width="60"></el-table-column>

          <el-table-column prop="cpbvmemo" label="备注" width="120"></el-table-column>
          <el-table-column prop="cinportop" label="提交人员" width="100"></el-table-column> -->

          <!-- <el-table-column prop="cddatasource" label="发票来源" width="100"></el-table-column>
          <el-table-column prop="cpasturecode" label="工厂编号" width="160"></el-table-column>
          <el-table-column prop="cpasturename" label="公司名称" width="160"></el-table-column>
          <el-table-column prop="cpbvcode" label="单据编号" width="120"></el-table-column>
          <el-table-column prop="cpasturename" label="公司名称" width="160"></el-table-column>
          <el-table-column prop="CreateUserId" label="制单人主键" width="120"></el-table-column>
          <el-table-column prop="csapcode" label="SAP单号" width="160"></el-table-column>
          <el-table-column prop="cvencode" label="供应商编号" width="120"></el-table-column>
          <el-table-column prop="cztcode" label="牧场编号" width="160"></el-table-column>
          <el-table-column prop="cpasturename" label="公司名称" width="160"></el-table-column>
          <el-table-column prop="iu8pbvid" label="U8发票ID" width="160"></el-table-column>
          <el-table-column prop="ModifyDate" label="变更时间" width="100">
            <template slot-scope="scope" v-if="scope.row.ModifyDate">
              {{scope.row.ModifyDate.substring(0,10)}}
            </template>
          </el-table-column>
          <el-table-column prop="ModifyUserId" label="变更人主键 " width="160"></el-table-column>
          <el-table-column prop="ModifyUserName" label="变更人" width="160"></el-table-column> -->

          <el-table-column label="操作" width="120" fixed="right">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" plain @click="addoption(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pull-right" style="padding:20px;">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10,20, 50, 100, 1000]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
          </el-pagination>
        </div>

      </div>
    </el-card>
    <operprint v-if="prinpageif" :prinpageif="prinpageif" :prinpagesrc="prinpagesrc" @printclose="printclose" />
  </div>
</template>

<script>
import operprint from "../Operation_SHOrder/Operation/Operatiopint.vue";
export default {
  components: { operprint },
  data() {
    return {
      alwaysUseStartDate: [],
      formInline: {
        cztcode: "",
        ddeliverytime: [],
      },

      tableRadio: {
        cddatasource: "",
        cexch_name: "人民币",
        cvouchtype: "纸质发票",
        cfpcode: "",
        cinportop: "",
        companyname: "",
        cpasturecode: "",
        cpasturename: "",
        cpbvcode: "",
        cpbvmemo: "",
        CreateDate: "",
        CreateUserId: "",
        CreateUserName: "",
        csapcode: "",
        cstatus: "",
        cvencode: JSON.parse(localStorage.getItem("userdata")).ccustomercode,
        cvenname: JSON.parse(localStorage.getItem("userdata")).ccustomername,
        cztcode: "",
        dinportdate: "",
        dpbvdate: "",
        iexch_rate: 1,
        iinport: "",
        itaxmoney: 0,
        itotalmoney: 0,
        itotalqty: "",
        iu8pbvid: "",
        ModifyDate: "",
        ModifyUserId: "",
        ModifyUserName: "",
      },

      orderlist: [],
      selectlist: {},
      prinpageif: false,
      prinpagesrc: "",
      pageSize: 20,
      pageIndex: 1,
      // 页数
      totalCount: 0,
      informdatanew: {},
    };
  },
  created() {
    if (this.$route.query.informdata) {
      if (this.$route.query.informdata.cztcode != undefined) {
        this.formInline = {};
        this.formInline = this.$route.query.informdata;
      }
    }
    this.GetInvoiceList();
    // 公司
    this.GetAccountInfo();
  },
  methods: {
    addoption(val) {
      if (val == 1) {
        this.tableRadio = {
          id: "",
          cddatasource: "",
          cexch_name: "人民币",
          cfpcode: "",
          cinportop: "",
          companyname: "",
          cpasturecode: "",
          cpasturename: "",
          cpbvcode: "",
          cpbvmemo: "",
          CreateDate: "",
          CreateUserId: "",
          CreateUserName: "",
          csapcode: "",
          cstatus: "",
          cvencode: JSON.parse(localStorage.getItem("userdata")).ccustomercode,
          cvenname: JSON.parse(localStorage.getItem("userdata")).ccustomername,
          cztcode: "",
          dinportdate: "",
          dpbvdate: "",
          iexch_rate: 1,
          iinport: "",
          itaxmoney: 0,
          itotalmoney: 0,
          itotalqty: "",
          iu8pbvid: "",
          ModifyDate: "",
          ModifyUserId: "",
          ModifyUserName: "",
        };
        // this.$router.push({ path: "/Operationadd", params:{id: "5464"}});
        this.$router.push({
          name: "InvoiceNoticeadd",
          params: {
            tableRadio: this.tableRadio,
            selectlist: this.selectlist,
            informdata: this.informdatanew,
          },
        });
      } else {
        this.tableRadio = val;
        this.$router.push({
          name: "InvoiceNoticeadd",
          params: {
            tableRadio: this.tableRadio,
            selectlist: this.selectlist,
            informdata: this.informdatanew,
          },
        });
      }
    },
    // 获取订单
    GetInvoiceList() {
      var starttime;
      var endtime;
      if (this.formInline.ddeliverytime != null) {
        if (this.formInline.ddeliverytime.length != 0) {
          starttime = this.formInline.ddeliverytime[0];
          endtime = this.formInline.ddeliverytime[1];
        } else {
          starttime = "";
          endtime = "";
        }
      } else {
        starttime = "";
        endtime = "";
      }
      this.informdatanew = JSON.parse(JSON.stringify(this.formInline));
      this.$axios({
        method: "post",
        url: "CommonModule/Op_StoreAndInvoice/GetInvoiceList",
        data: {
          starttime: starttime,
          endtime: endtime,
          cztcode: this.formInline.cztcode,
          pageSize: this.pageSize,
          pageIndex: this.pageIndex,
        },
      }).then((res) => {
        console.log(res);
        if (res.data.rows) {
          this.totalCount = res.data.totalCount;
          this.orderlist = res.data.rows;
        }
      });
    },
    GetAccountInfo() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_StoreAndInvoice/GetAccountInfo",
      }).then((res) => {
        console.log(res);
        if (res.data.Success) {
          if (res.data.Message) {
            this.selectlist = res.data.Data;
          }
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    clickChange(item) {
      this.tableRadio = item;
    },

    printclose(val) {
      this.prinpageif = val;
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetInvoiceList();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.GetInvoiceList();
    },
  },
};
</script>
